export default __webpack_public_path__ + "static/media/icon-money.3946827f.svg";